import { FaqState } from "./types";

export const defaultState = (): FaqState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    faqs: [],
    links: {}
  };
};

export const state = defaultState();
